import React, { useRef, useState } from "react";
import classNames from "classnames";
import { Info } from "Components/Icons";
import { Tooltip, UncontrolledTooltip } from "Components/ReactstrapSlim";
import { useClickOutside } from "Hooks";
import * as Popper from "popper.js";

interface ModuleCaptionTooltipIconProps {
   className?: string
   isActive?: boolean,
   onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void,
}

interface ModuleCaptionTooltipInnerProps {
   targetClassName?: string
   tooltipClassName?: string
   placement?: Popper.Placement
}

export interface ModuleCaptionTooltipProps extends ModuleCaptionTooltipInnerProps {
   openOnClick?: boolean
}

const ModuleCaptionTooltipIcon = React.forwardRef<HTMLSpanElement, ModuleCaptionTooltipIconProps>(({ className, isActive, onClick }, ref) => {
   return <span ref={ref} onClick={onClick} className={classNames(
      "management-module-caption-tooltip-icon",
      { "management-module-caption-tooltip-icon--active": isActive },
      className)}>
      &#65279;
      <Info />
   </span>
})

const ModuleCaptionTooltip: React.FC<ModuleCaptionTooltipProps> = ({ openOnClick, ...rest }) => {
   if (openOnClick)
      return <ModuleCaptionTooltipControlled {...rest} />
   else
      return <ModuleCaptionTooltipUncontrolled {...rest} />
}

const ModuleCaptionTooltipUncontrolled: React.FC<ModuleCaptionTooltipInnerProps> = ({ children, tooltipClassName, targetClassName, placement = "top" }) => {
   const tooltipRef = useRef<HTMLSpanElement>(null);
   return <>
      <ModuleCaptionTooltipIcon ref={tooltipRef} className={targetClassName} />
      <UncontrolledTooltip target={tooltipRef} placement={placement} className={classNames("management-module-caption-tooltip", tooltipClassName)} fade={false}>
         {children}
      </UncontrolledTooltip>
   </>
}

const ModuleCaptionTooltipControlled: React.FC<ModuleCaptionTooltipInnerProps> = ({ children, tooltipClassName, targetClassName, placement = "top" }) => {
   const tooltipIconRef = useRef<HTMLSpanElement>(null);
   const tooltipRef = useRef<HTMLDivElement>(null);
   const [isOpen, setIsOpen] = useState(false);
   const toggle = () => {
      setIsOpen((wasOpen) => !wasOpen);
   }
   useClickOutside(tooltipRef, () => {
      setIsOpen(false);
   })
   return <>
      <ModuleCaptionTooltipIcon ref={tooltipIconRef} className={classNames("management-module-caption-tooltip-icon-clickable", targetClassName)} onClick={() => toggle()} isActive={isOpen} />
      <Tooltip target={tooltipIconRef} isOpen={isOpen} toggle={toggle} placement={placement} className={classNames("management-module-caption-tooltip", tooltipClassName)} fade={false} autohide={false} trigger={"click"} hideArrow>
         <div ref={tooltipRef}>
            {children}
         </div>
      </Tooltip>
   </>
}

export default ModuleCaptionTooltip